import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.8 15.5L18.4 9.80005C18.8 9.40005 18.8 8.80005 18.4 8.40005C18 8.00005 17.4 8.00005 17 8.40005L12 13.3L7.00005 8.40005C6.60005 8.00005 6.00005 8.00005 5.60005 8.40005C5.40005 8.60005 5.30005 8.80005 5.30005 9.10005C5.30005 9.40005 5.40005 9.60005 5.60005 9.80005L11.2 15.5C11.7 15.9 12.3 15.9 12.8 15.5C12.7 15.5 12.7 15.5 12.8 15.5Z",
		fill: "currentColor"
	})
});
export default SvgChevronDown;
